/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://clara-issue-tracking-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://clara-issue-tracking-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/cn3-issue-tracking-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
